import type { Locomotion } from '../../../../vrroom_typescript/src/platform/contracts';
export function classifyLocomotion(speed: number, mode: 'fly'|'walk', grounded: boolean, running: boolean): Locomotion {
    if (mode === 'fly') return speed < 0.15 ? 'idle' : 'fly';
    if (!grounded) return 'jump';
    if (speed < 0.15) return 'idle';
    return running || speed > 3 ? 'run' : 'walk';
}
